import Login from '../views/ClientLogin'
import AcceptInvitation from '../views/AcceptInvitation'
import ForgotPassword from '../views/ClientForgotPassword'
import ClientDashboard from '../views/ClientDashboard__Custom.vue'
import ResetPassword from '../views/ClientResetPassword'
import Overview from '../views/dashboard/Overview__Custom'
import List from '../views/lessons/List'
import AccountSettings from '../views/account/AccountSettings.vue'
import SchoolReportsDashboard from '../views/reports/schools/SchoolReportsDashboard.vue'
import TeacherReportsDashboard from '../views/reports/teachers/TeacherReportsDashboard.vue'
import ClassReportsDashboard from '../views/reports/classes/ClassReportsDashboard__Custom.vue'
import ParentReportsDashboard from '../views/reports/parents/ParentReportsDashboard.vue'
import LearningAreaReportsDashboard from '../views/reports/learningareas/LearningAreaReportsDashboard.vue'
import LessonReportsDashboard from '../views/reports/lessons/LessonReportsDashboard.vue'

export default [
  {
    path: '/client/dashboard',
    name: 'Client Dashboard',
    component: ClientDashboard,
    redirect: '/client/dashboard/overview',
    meta: {
      private: true,
      type: 'client'
    },
    children: [
      {
        path: 'overview',
        name: 'Client Dashboard Overview',
        component: Overview,
        meta: {
          type: 'client'
        }
      },
      {
        path: 'lessons',
        name: 'Client Lesson Preview',
        component: List,
        meta: {
          type: 'client'
        }
      },
      {
        path: 'reports/schools',
        name: 'Client School Reports',
        component: SchoolReportsDashboard,
        meta: {
          type: 'client'
        }
      },
      {
        path: 'reports/teachers',
        name: 'Client Teacher Reports',
        component: TeacherReportsDashboard,
        meta: {
          type: 'client'
        }
      },
      {
        path: 'reports/users',
        name: 'Client User Reports',
        component: ClassReportsDashboard,
        meta: {
          type: 'client'
        }
      },
      {
        path: 'reports/parents',
        name: 'Client Parent Reports',
        component: ParentReportsDashboard,
        meta: {
          type: 'client'
        }
      },
      {
        path: 'reports/learningareas',
        name: 'Client Learning Area Reports',
        component: LearningAreaReportsDashboard,
        meta: {
          type: 'client'
        }
      },
      {
        path: 'reports/lessons',
        name: 'Client Lessons Reports',
        component: LessonReportsDashboard,
        meta: {
          type: 'client'
        }
      },
      {
        path: 'account',
        name: 'Client Account',
        component: AccountSettings,
        meta: {
          type: 'client'
        }
      }
    ]
  },
  {
    path: '/client/login',
    name: 'Client Login',
    component: Login,
    meta: {
      type: 'client'
    }
  },
  {
    path: '/client/accept-invitation',
    name: 'Client Accept Invitation',
    component: AcceptInvitation,
    meta: {
      type: 'client'
    }
  },
  {
    path: '/client/forgotpassword',
    name: 'Client Password Reset',
    component: ForgotPassword,
    meta: {
      type: 'client'
    }
  },
  {
    path: '/client/reset-password',
    name: 'Client Resert Passowrd',
    component: ResetPassword,
    meta: {
      type: 'client'
    }
  }
]
